import React from 'react'
import Button from 'react-bootstrap/Button'

const NewRecordNavigation = (props) => {
    const nextStep = () => {
        props.onChangeStep(props.currentStep + 1)
    }

    const prevStep = () => {
        props.onChangeStep(props.currentStep - 1)
    }

    return (
        <div className="mt-1">
            {props.currentStep > 0 &&
                <div className="float-start">
                    {props.showLabels &&
                        <div className="mb-2 ml-1">
                            &#8249; {props.steps[props.currentStep - 1].label}
                        </div>
                    }
                    <Button variant="primary" size="lg" className="px-4" onClick={prevStep}>
                        Back
                    </Button>
                </div>
            }
            {props.steps && props.currentStep < props.steps.length - 1
                ? <div className="float-end text-end">
                    {props.showLabels &&
                        <div className="mb-2 mr-1">
                            {props.steps[props.currentStep + 1].label} &#8250;
                        </div>
                    }
                    <Button variant="primary" size="lg" className="px-4" onClick={nextStep}>
                        Next
                    </Button>
                  </div>
                : <div className="float-end text-end">
                    {props.showLabels &&
                        <div className="mb-2 mr-1">&nbsp;</div>
                    }
                    <Button variant="primary" size="lg" className="px-4" onClick={props.onSubmit}>
                        {props.recordId
                            ? <>Save and submit for review</>
                            : <>Update and submit for review</>
                        }
                    </Button>
                  </div>
            }
        </div>
    )
}

export default NewRecordNavigation